export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sync.worker.75c67c2a.worker.js");
}
